import React, { useState, createContext, useContext } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Home from './pages/Home';
import Catalogo from './pages/Catalogo';
import Carrito from './pages/Carrito';
import Checkout from './pages/Checkout';
import Login from './pages/Login';
import Registro from './pages/Registro';
import Admin from './pages/Admin';
import Perfil from './pages/Perfil';
import DetalleProducto from './pages/DetalleProducto';
import Contacto from './pages/Contacto';

// Contexto de autenticación simple
const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  // Simulación de login
  const login = (username, password) => {
    if (username === 'admin@admin.com' && password === '1234') {
      setUser({ username: 'admin@admin.com' });
      return true;
    }
    return false;
  };
  const logout = () => setUser(null);
  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

// Ruta protegida para solo usuarios logueados
function PrivateRoute({ element }) {
  const { user } = useAuth();
  return user ? element : <Navigate to="/login" replace />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          {/* Header con logo placeholder */}
          <header className="app-header">
            {/* Lugar reservado para el logo de la marca (no incluir imagen ni nombre comercial) */}
            <div className="logo-placeholder">LOGO</div>
            <nav className="main-nav">
              <a href="/">Inicio</a>
              <a href="/catalogo">Catálogo</a>
              <a href="/carrito">Carrito</a>
              <a href="/login">Ingresar</a>
              <a href="/admin">Admin</a>
            </nav>
          </header>
          {/* Layout de páginas principales */}
          <main className="app-main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catalogo" element={<Catalogo />} />
              <Route path="/carrito" element={<PrivateRoute element={<Carrito />} />} />
              <Route path="/checkout" element={<PrivateRoute element={<Checkout />} />} />
              <Route path="/login" element={<Login />} />
              <Route path="/registro" element={<Registro />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/perfil" element={<PrivateRoute element={<Perfil />} />} />
              <Route path="/producto/:id" element={<DetalleProducto />} />
              <Route path="/contacto" element={<Contacto />} />
            </Routes>
          </main>
          {/* Footer con espacio reservado para branding */}
          <footer className="app-footer">
            <div className="footer-content">
              <a href="/contacto" className="footer-link">Contacto y Devoluciones</a>
              <span className="footer-copyright">Desarrollado por webXpert. Todos los derechos reservados. © {new Date().getFullYear()}</span>
            </div>
          </footer>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
